import { createReducer, on } from "@ngrx/store";
import { SignatureGroup } from "../../models/signature-group";
import { loadSignatureGroupByIdAct, resetSignatureGroupAct, saveSuccessSignatureGroupAct, setViolationsSignatureGroupAct, updateSuccessSignatureGroupAct } from "./signatures.actions";

const signatureGroup: SignatureGroup = new SignatureGroup();

export const signatureGroupReducer = createReducer(
    {
        signatureGroup,
        violations: {},
        loading: true
    },
    on(resetSignatureGroupAct, (state) => ({
        signatureGroup:  { ...signatureGroup },
        violations: {},
        loading: state.loading
    })),
    on(loadSignatureGroupByIdAct, (state, { signatureGroup }) => ({
        signatureGroup: { ...signatureGroup },
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessSignatureGroupAct, (state, { signatureGroupNew }) => ({
        signatureGroup: { ...signatureGroupNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessSignatureGroupAct, (state, { signatureGroupUpdated }) => ({
        signatureGroup: { ...signatureGroupUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsSignatureGroupAct, (state, { signatureGroupForm, violations }) => ({
        signatureGroup: { ...signatureGroupForm },
        violations: {...violations},
        loading: false
    }))
);